import BoletosPedidosService from '@/services/Operacoes/Boleto.service';
import Notifier from '@/libs/Notifier';

const boletosService = new BoletosPedidosService();
const notify = new Notifier();

export default {
  namespaced: true,
  state: () => ({
    setIsLoadingBoleto: false,
    generetedBoletoLoading: false,
    query: {
      pedidoid: null,
      clienteid: null,
    },
    boletos: [],
    message: '',
    generatedBoletoUrl: null,

  }),

  actions: {
    async getBoletos({ commit, state }) {
      try {
        commit('SET_IS_LOADING_BOLETO', true);
        const response = await boletosService.getBoletos(state.query);
        if (response.data.length === 0) {
          commit('SET_IS_LOADING_BOLETO', false);
          commit('SET_MESSAGE', response.message);
          notify.warning(response.message);
          return;
        }

        commit('SET_BOLETOS', response.data);

        notify.success('Boletos carregados com sucesso');
      } catch (error) {
        notify.error(error, 'Erro ao buscar lista de boletos');
      } finally {
        commit('SET_IS_LOADING_BOLETO', false);
      }
    },

    async generateBoleto({ commit, state }, data) {
      try {
        commit('SET_GENERETED_BOLETO_LOADING', true);
        const response = await boletosService.generateBoleto(data);
        console.log('response', response);
        const url = window.URL.createObjectURL(new Blob([response]));
        console.log('url', url);
        state.generatedBoletoUrl = url;

        commit('SET_MESSAGE', response.message);
        notify.success(response.message);
      } catch (error) {
        notify.error(error, 'Erro ao gerar boleto');
      } finally {
        commit('SET_GENERETED_BOLETO_LOADING', false);
      }
    },

  },

  mutations: {
    SET_IS_LOADING_BOLETO(state, value) {
      state.setIsLoadingBoleto = value;
    },
    SET_QUERY(state, query) {
      state.query.clienteid = query.clienteid;
      state.query.pedidoid = query.pedidoid;
    },

    SET_BOLETOS(state, data) {
      state.boletos = data;
    },
    SET_MESSAGE(state, message) {
      state.message = message;
    },
    SET_GENERETED_BOLETO_LOADING(state, value) {
      state.generetedBoletoLoading = value;
    },
    SET_GENERATED_URL(state, data) {
      state.generatedBoletoUrl = data;
    },
  },

};
